(function() { window.GUID_af888ad5_c558_415b_bbd2_9008bf4ff104 = { getGuid: function() { return "af888ad5-c558-415b-bbd2-9008bf4ff104"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class MasterPageSignalR {
            constructor(masterPage) {
                let me = this;
                CS.Views.MasterPageSignalR.Current = me;
                me.masterPage = masterPage;
                me.signalRHelper = CS.SignalRHelper.Instance;
                me.signalRHelper.Start("Messages", function () {
                    me.signalRHelper.Invoke("ListenForMessages", null, CS.CommonData.Current.UserId);
                });
                me.signalRHelper.Receive("MessageReceived", function (response) {
                    if (me.signalRHelper.Logging) {
                        console.info("MessageReceived");
                    }
                    CS.Lag("master-message-received", 150, function () {
                        masterPage.OnNewMessagesReceived();
                    });
                });
                me.signalRHelper.Receive("SendMessageReceived", function (response) {
                    if (me.signalRHelper.Logging) {
                        console.info("SendMessageReceived");
                    }
                    CS.Lag("master-message-received", 150, function () {
                        masterPage.OnNewMessagesReceived();
                    });
                });
            }
            Stop() {
                this.signalRHelper.Stop("Messages", "StopListeningForMessages", CS.CommonData.Current.UserId);
            }
        }
        Views.MasterPageSignalR = MasterPageSignalR;
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=masterpage.signalr.pre.js.map
